import { Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { SignupComponent } from './authentication/signup/signup.component';
import { ShopComponent } from './shop/shop.component';
import { pagesRoutes } from './pages/pages.routes';
import { ProductComponent } from './product/product.component';
import { settingsRoutes } from './settings/settings.routes';
import { authGuard, checkAbandoneOrNoAddressdUser, maintenanceGuard, checkMembershipPermissions, checkNoPaymentMethodUser, maintenanceOffGuard, preventForAbandoneOrNoAddressdUser } from './shared/guards/auth-guard.guard';
import { HomeComponent } from './home/home.component';
import { TermsAndConditionsComponent } from './authentication/signup/terms-and-conditions/terms-and-conditions.component';
import { accountRecoveryRoutes } from './authentication/account-recovery/account-recovery.routes';
import { FavProductsComponent } from './fav-products/fav-products.component';
import { BuyAgainProductsComponent } from './buy-again-products/buy-again-products.component';
import { CustomBoxComponent } from './shared/custom-box/custom-box.component';
import { canDeactivateGuard } from './shared/guards/deactivate/can-deactivate.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { EcommerceAdminComponent } from './authentication/ecommerce-admin/ecommerce-admin.component';
import { PreferencesSignupComponent } from './authentication/signup/preferences-signup/preferences-signup.component';
import { SideCheckoutComponent } from './side-checkout/side-checkout.component';
import { BlankComponent } from './shared/blank-component/blank.component';

export const routes: Routes = [
  {
    path: 'maintenance',
    title: 'Maintenance',
    component: MaintenanceComponent,
    canActivate: [maintenanceOffGuard]
  },
  {
    path: 'ecommerce-admin/:token',
    title: 'Ecommerce Admin',
    component: EcommerceAdminComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: '',
    title: 'Home',
    component: HomeComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    title: 'Log In',
    component: LoginComponent,
    canActivate: [maintenanceGuard, authGuard]
  },
  {
    path: 'signup',
    title: 'Sign Up',
    component: SignupComponent,
    canActivate: [maintenanceGuard]
  },
  ...pagesRoutes,
  ...settingsRoutes,
  ...accountRecoveryRoutes,
  {
    path: 'shop',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    canActivateChild: [maintenanceGuard]

  },
  {
    path: 'shop/:category',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser]

  },
  {
    path: 'shop/custom-box/:bundleEditionType/:productId',
    title: 'Shop Custom Box',
    component: CustomBoxComponent,
    pathMatch: 'full',
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'shop/:category/:subcategory/:product',
    title: 'Product',
    component: ProductComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'favorites',
    title: 'Favorites',
    component: FavProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'preferences',
    title: 'Preferences',
    component: PreferencesSignupComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'buy-again',
    title: 'Buy again',
    component: BuyAgainProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'order',
    title: 'Order',
    component: SideCheckoutComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions],
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions',
    component: TermsAndConditionsComponent,
    canActivate: [maintenanceGuard]
  },

  {
    path: 'order/custom-box/:bundleEditionType',
    title: 'Order Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'order/custom-box/:bundleEditionType/:productId',
    title: 'Order Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'product/custom-box/:bundleEditionType/:productId',
    title: 'Product Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'signup/custom-box/:bundleEditionType/:productId',
    title: 'Sign Up Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'free-eggs',
    loadComponent: () => import('./campaign/campaign.component').then(m => m.CampaignComponent)
  },
  {
    path: 'free-eggs10',
    loadComponent: () => import('./free-eggs-10/free-eggs-10.component').then(m => m.FreeEggs10Component)
  },
  {
    path: 'sms-opt-in',
    component: BlankComponent,
  },
  { path: '**', redirectTo: '' },
];
